export default __webpack_public_path__ + "static/media/back.5367c958.svg";